import { Descriptions, Typography, Flex, Tag, Spin } from "antd";
import "./styles/styles.css"; // optional custom styling
import { getProfile } from "./apis/getProfile";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
const { Title } = Typography;

export const ProfilePage = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["userProfile"],
    queryFn: getProfile,
  });

  const user = useMemo(() => {
    return data?.data?.user;
  }, [data]);

  if (isLoading) {
    return (
      <Flex align="center" justify="center">
        <Spin size="large" />
      </Flex>
    );
  }

  if (error) {
    return <Title level={2}>Something went wrong</Title>;
  }

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      className="profile-view-container"
    >
      <Descriptions
        bordered
        column={1}
        labelStyle={{
          fontWeight: "bold",
          width: "200px",
        }}
        contentStyle={{
          minWidth: "300px",
          textAlign: "left",
        }}
        size="middle"
        className="profile-description"
      >
        <Descriptions.Item label="Name">{user?.name}</Descriptions.Item>
        <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>
        <Descriptions.Item label="LinkedIn URL">
          <a
            href={user?.linkedInProfileURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {user?.linkedInProfileURL}
          </a>
        </Descriptions.Item>
        <Descriptions.Item label="Verification Status">
          <Tag color={user?.isVerified ? "green" : "red"}>
            {user?.isVerified ? "Verified" : "Pending"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Area of Expertise">
          {user?.details?.areaOfExpertise}
        </Descriptions.Item>
        <Descriptions.Item label="Geo">
          {user?.details?.geoOptions}
        </Descriptions.Item>
        <Descriptions.Item label="Years of Experience">
          {user?.details?.yearsOfExperience}
        </Descriptions.Item>
        {/* <Descriptions.Item label="Cost / Session">
          {user?.cost === 0 ? "Free" : `$${user?.cost}`}
        </Descriptions.Item> */}
        <Descriptions.Item label="Professional Summary">
          {user?.details?.professionalSummary || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Role">
          {user?.role?.split("_").join(" ")}
        </Descriptions.Item>
        {user?.stripeAccountId && (
          <Descriptions.Item label="Stripe Connect ID">
            {user?.stripeAccountId}
          </Descriptions.Item>
        )}
      </Descriptions>
    </Flex>
  );
};
